<onyx-section [heading]="`${I18N}.heading.${hasTank() ? 'tank' : 'default'}`">
  <form [formGroup]="form()">
    @let controls = form().controls;
    <onyx-form-group [controls]="controls.loadCapacity">
      <onyx-text-field
        data-testid="load-capacity-field"
        [formControl]="controls.loadCapacity"
        [warning]="controls.loadCapacity.value | unitWarning: 'vehicleWeight'"
        label="labels.loadCapacity"
        [decimalPlaces]="0"
        unit="kg"
        [size]="32"
        [showErrors]="false"
      ></onyx-text-field>

      <onyx-suggestions
        [control]="controls.loadCapacity"
        [suggestions]="
          controls.loadCapacity.value | unitSuggestions: 'vehicleWeight'
        "
      ></onyx-suggestions>
    </onyx-form-group>

    @if (controls.volumeCapacity.enabled) {
      <onyx-text-field
        data-testid="volume-capacity-field"
        [formControl]="controls.volumeCapacity"
        label="labels.volumeCapacity"
        [decimalPlaces]="2"
        unit="m³"
        [size]="32"
      ></onyx-text-field>
    }

    @if (controls.chambersNumber.enabled) {
      <onyx-tabs
        data-testid="chambers-number-tabs"
        [formControl]="controls.chambersNumber"
        [tabs]="chambersNumbers$ | async"
        label="labels.chambersNumber"
        [fill]="true"
        [size]="32"
        width="100%"
      ></onyx-tabs>
    }

    @if (controls.tankCertificates.enabled) {
      <onyx-dropdown
        data-testid="tank-certificates-dropdown"
        [formControl]="controls.tankCertificates"
        label="labels.tankCertificates"
        [options]="tankCertificates$ | async"
        [multiple]="true"
        [size]="32"
      ></onyx-dropdown>
    }

    @let dischargeTypesControl = controls.dischargeTypes;
    @if (dischargeTypesControl.enabled || dischargeTypesControl.value) {
      <onyx-dropdown
        data-testid="discharge-types-dropdown"
        [formControl]="controls.dischargeTypes"
        label="labels.dischargeType"
        [options]="dischargeTypes()"
        [multiple]="true"
        [size]="32"
      ></onyx-dropdown>
    }

    <div class="break"></div>

    @if (controls.europalletsNumber.enabled) {
      <onyx-form-group [controls]="controls.europalletsNumber">
        <onyx-text-field
          data-testid="europallets-number-field"
          [formControl]="controls.europalletsNumber"
          label="labels.europalletsNumber"
          [decimalPlaces]="0"
          unit="units.pieces"
          [showErrors]="false"
          [size]="32"
        ></onyx-text-field>

        <onyx-suggestions
          [control]="controls.europalletsNumber"
          [suggestions]="europalletsNumberSuggestions()"
        ></onyx-suggestions>
      </onyx-form-group>
    }

    @if (controls.length.enabled) {
      <onyx-form-group [controls]="controls.length">
        <onyx-text-field
          data-testid="length-field"
          [formControl]="controls.length"
          [warning]="controls.length.value | unitWarning: 'cargoLength'"
          label="labels.length"
          [decimalPlaces]="2"
          unit="m"
          [showErrors]="false"
          [size]="32"
        ></onyx-text-field>

        <onyx-suggestions
          [control]="controls.length"
          [suggestions]="
            (controls.length.value | unitSuggestions: 'cargoLength') ??
            (isSemiTrailer() ? LENGTH_SUGGESTIONS : [])
          "
        ></onyx-suggestions>
      </onyx-form-group>
    }

    @if (controls.width.enabled) {
      <onyx-form-group [controls]="controls.width">
        <onyx-text-field
          data-testid="width-field"
          [formControl]="controls.width"
          [warning]="controls.width.value | unitWarning: 'cargoWidth'"
          label="labels.width"
          [decimalPlaces]="2"
          unit="m"
          [showErrors]="false"
          [size]="32"
        ></onyx-text-field>

        <onyx-suggestions
          [control]="controls.width"
          [suggestions]="
            (controls.width.value | unitSuggestions: 'cargoWidth') ??
            (isSemiTrailer() ? WIDTH_SUGGESTIONS : [])
          "
        ></onyx-suggestions>
      </onyx-form-group>
    }

    @if (controls.height.enabled) {
      <onyx-form-group [controls]="controls.height">
        <onyx-text-field
          data-testid="height-field"
          [formControl]="controls.height"
          [warning]="controls.height.value | unitWarning: 'cargoHeight'"
          label="labels.height"
          [decimalPlaces]="2"
          unit="m"
          [showErrors]="false"
          [size]="32"
        ></onyx-text-field>

        <onyx-suggestions
          [control]="controls.height"
          [suggestions]="
            (controls.height.value | unitSuggestions: 'cargoHeight') ??
            (isSemiTrailer() ? HEIGHT_SUGGESTIONS : [])
          "
        ></onyx-suggestions>
      </onyx-form-group>
    }
  </form>
</onyx-section>
